import PropTypes from 'prop-types';
import breakPoints from 'helpers/Styles';
import React, { useState, useEffect, useContext } from 'react';
import { StorefrontContext } from 'providers/storefront';
import Link from 'next/link';

const TabMenu = ({ tabIndex, menuItems, minWidth }) => {
  const marginRight = menuItems?.length > 2 ? '30px' : '40px';
  const { setIsAnnouncementBarOpen, isAnnouncementBarOpen } =
    useContext(StorefrontContext);
  const [navbar, setNavbar] = useState(false);
  const [isHoveredIcon, setIsHoveredIcon] = useState(false);

  const handleMouseEnter = () => {
    setIsHoveredIcon(true);
  };

  const handleMouseLeave = () => {
    setIsHoveredIcon(false);
  };

  const handleNavbar = () => {
    if (window.scrollY >= `${isAnnouncementBarOpen ? 33 : 49}`) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };
  useEffect(() => {
    window.addEventListener('scroll', handleNavbar);

    return () => window.removeEventListener('scroll', handleNavbar);
  }, []);
  return (
    <div className="head_tab_button">
      <div
        className={`${
          menuItems && menuItems?.length > 4 ? 'tabContainer' : ''
        }`}
      >
        <div className="tab_button_block">
          <div className="wrapper ">
            <div className="tab_buttons">
              {menuItems.map((item, index) => (
                <Link href={item.link || '#'} key={item.menu_item_title}>
                  <a
                    href={item.link || '#'}
                    className={`tab_option ${
                      tabIndex === index ? 'active' : null
                    }`}
                    target={!item.link.startsWith('/') ? '_blank' : ''}
                    rel="noreferrer"
								aria-label={item.menu_item_title}
                  >
                    {item.menu_item_title}
                    {!item.link.startsWith('/') && (
                      <div 
                        className="external_link"       
                        onMouseEnter={handleMouseEnter}                      
                        onMouseLeave={handleMouseLeave}
                      >
                        <img src={isHoveredIcon 
                          ? "https://cdn.shopify.com/s/files/1/0637/0407/2436/files/external-link-hover.svg?v=1714050214" 
                          : "https://cdn.shopify.com/s/files/1/0637/0407/2436/files/external-link.svg?v=1714050213"
                        } alt="" />
                      </div>
                    )}
                  </a>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>

      <style jsx>
        {`
          .head_tab_button {
            position: sticky;
          }
          .tab_button_block {
            width: 100%;
            background: #242424;
            overflow: auto;
            // z-index: 3;
          }
          .tab_buttons {
            height: 65px;
            background: #242424;
            width: 100%;
            display: flex;
            justify-content: center;
            position: relative;
            line-height: 65px;
            margin: auto;
            gap: ${marginRight};
          }
          .tab_option {
            color: white;
            cursor: pointer;
            color: #949494;
            font-family: 'Roboto-Medium';
            font-size: 16px;
            letter-spacing: 0;
            display: block;
            // margin-right: 30px;
          }
          .tab_option:hover {
            color: #e4e4e4;
          }
          .active {
            color: #e4e4e4;
            border-bottom: 2px solid #fd0300;
          }
          .external_link {
            display: inline-block;
            height: 14px;
            width: 16px;
            margin-left: 6px;
          }

          @media (max-width: ${breakPoints.medium}) {
            .tab_button_block {
              background: #242424;
            }
            .tab_buttons {
              min-width: ${minWidth};
              line-height: 60px;
            }
          }
          @media (max-width: 600px) {
            .tabContainer {
              height: 65px;
              width: 100%;
              position: relative;
              padding-right: 40px;
              background: #242424;
            }

            .tabContainer::after {
              content: '';
              width: 60px;
              background: linear-gradient(to left, rgb(0 0 0), rgb(0 0 0 / 2%));
              height: 65px;
              position: absolute;
              right: 0;
              top: 0;
            }
          }
        `}
      </style>
    </div>
  );
};

TabMenu.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  menuItems: PropTypes.array,
  tabIndex: PropTypes.number,
};

TabMenu.defaultProps = {
  menuItems: [],
  tabIndex: 0,
};

export default TabMenu;
